/**
 cate and subcate data store
*/
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export const cate = {
    namespaced: true,
    state: {
        cateItem: [],
        filterType: null,
        anchorType: null
    },
    mutations: {
        setCateItem(state, payload) {
            state.cateItem = payload
        },
        setFilterType(state, payload) {
            state.filterType = payload
        },
        setAnchorType(state, payload) {
            state.anchorType = payload
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/cate.js